import React from 'react'
import axios from 'axios'
import { feature } from "topojson-client"
import VectorMap from '../Components/VectorMap'
import Tooltip from '../Components/Tooltip'

/* Component for visualizing data on specific state map. */
export default class StateMap extends React.Component {
    constructor(props) {
        super(props)
        /* Define mouseEnter event for map components. */
        this.mouseEnter = (event, name) => {
            this.setState(
                {
                    currentData: name,
                    tooltipPosition: {
                        top: event.pageY,
                        left: event.pageX,
                    },
                }
            )
            this.props.analytics.enter("county", `${name}`)
        }
        /* Define mouseMove event for map components. */
        this.mouseMove = (event, name) => {
            this.setState(
                {
                    currentData: name,
                    tooltipPosition: {
                        top: event.pageY,
                        left: event.pageX,
                    },
                }
            )
            this.props.analytics.move("county", `${name}`)
        }
        /* Define mouseLeave event for map components. */
        this.mouseLeave = (event, name) => {
            this.setState(
                {currentData: null}
            )
            this.props.analytics.exit("county", `${name}`)
        }
        /* Determine state. */
        this.state = {
            mapData: null,
            currentData: null,
            tooltipPosition: {
                top: 0,
                left: 0,
            },
        }
    }

    componentDidMount() {
        /* Fetch county geography. */
        axios.get("counties-albers-topo.json").then((response) => {
            /* Convert topojson to geojson. */
            const geojson = feature(response.data, response.data.objects.counties)
            /* Convert geojson to desired format. */
            const data = geojson.features.map(
                (entry) => ({
                    state: entry.properties.state,
                    name: entry.properties.name,
                    geo: entry.geometry
                })
            ).filter((entry) => (entry.state === this.props.name))
            /* Update state with fetched data. */
            this.setState({
                mapData: data
            })
        })
    }

    render() {
        /* Fetch prop variables. */
        const { data } = this.props
        /* Fetch state variables. */
        const { mapData, currentData, tooltipPosition } = this.state
        /* Render. */
        return (
            <React.Fragment>
                { data != null && 
                    <React.Fragment>
                        <VectorMap
                            mapData={mapData}
                            colorData={data.counties}
                            width={400}
                            height={400}
                            mouseEnter={this.mouseEnter}
                            mouseLeave={this.mouseLeave}
                            mouseMove={this.mouseMove}
                        />
                        <Tooltip
                            position={tooltipPosition}
                            name={currentData}
                            data={data.counties[currentData]}
                        />
                    </React.Fragment>
                }
            </React.Fragment>
        )
    }
}